module.exports = __webpack_public_path__ + "ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ec.svg
// module id = 783
// module chunks = 0